import { HTMLAttributes } from 'react';
import { cn } from '../lib/utils';

export type MessageContentProps = HTMLAttributes<HTMLDivElement> & {
  compact?: boolean;
};

export const MessageContent = ({ children, className, ...props }: MessageContentProps) => (
  <div
    className={cn(
      'flex flex-col gap-2.5 overflow-hidden p-0 text-foreground text-[14px]',
      'group-[.is-user]:bg-primary group-[.is-user]:text-primary-foreground',
      'group-[.is-assistant]:bg-secondary group-[.is-assistant]:text-foreground',
      'is-user:dark overflow-visible',
      className
    )}
    {...props}
  >
    {children}
  </div>
);
